import { render, staticRenderFns } from "./HMPublicChat.vue?vue&type=template&id=cef56280&"
import script from "./HMPublicChat.vue?vue&type=script&lang=js&"
export * from "./HMPublicChat.vue?vue&type=script&lang=js&"
import style0 from "./HMPublicChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports